<div class="word-break" *ngIf="msgType === 'error'">
    <span>{{i18n.excuteFailedLab1}}</span>
    <a (click)="jump()">{{i18n.taskCenterLab}}</a>
    <span>{{i18n.excuteFailedLab2}}</span>
</div>
<div class="word-break" *ngIf="msgType === 'success'">{{i18n.excuteSuccess}}</div>
<div>
    <span>{{i18n.nameLab}}</span>
    <span class="word-break">{{taskName}}</span>
</div>
<div *ngIf="objName">
    <span>{{i18n.targetLab}}</span>
    <span class="word-break" [innerHTML]="replaceBlock(objName)"></span>
</div>
<div *ngIf="msgType === 'success'">
    <a (click)="jump()">{{i18n.viewDetail_info}}</a>
</div>
